export default {
  "Invest": {
    en: "Invest",
    ja: "投資"
  },
  "Manage": {
    en: "Manage",
    ja: "管理"
  }
}